import React from "react";

import { ReactComponent as PictureDodo } from "../images/art/birds/dodo.svg";
import { ReactComponent as PictureEmu } from "../images/art/birds/emu.svg";
import { ReactComponent as PictureFlamingo } from "../images/art/birds/flamingo.svg";
import { ReactComponent as PictureKiwi } from "../images/art/birds/kiwi.svg";
import { ReactComponent as PictureKakapo } from "../images/art/birds/kakapo.svg";

export default class Flags extends React.Component {
	render() {
		switch (this.props.flag) {
			case 0: return <PictureDodo fill={this.props.color || 'black'} />
			case 1: return <PictureEmu fill={this.props.color || 'black'} />
			case 2: return <PictureFlamingo fill={this.props.color || 'black'} />
			case 3: return <PictureKiwi fill={this.props.color || 'black'} />
			case 4: return <PictureKakapo fill={this.props.color || 'black'} />
			default: return <PictureDodo fill={this.props.color || 'black'} />
		}
	}
}